import { useEffect } from "react";
import "../assets/css/appToast.css";

export default function AppToast({ toast, onClose }) {
  useEffect(() => {
    if (!toast) return;

    const timer = setTimeout(() => {
      onClose();
    }, 4000);

    return () => clearTimeout(timer);
  }, [toast, onClose]);

  if (!toast) return null;

  return (
    <div className={`bank-toast ${toast.type}`}>
      <div className="bank-toast-icon">
        {toast.type === "success" ? "✓" : "!"}
      </div>

      <div className="bank-toast-content">
        <div className="bank-toast-title">{toast.title}</div>
        <div className="bank-toast-message">{toast.message}</div>
      </div>

      <button className="bank-toast-close" onClick={onClose}>
        ×
      </button>
    </div>
  );
}